import { log } from "~features/seated-reservation/helpers/stateLogger";
import { dontUnselectSeatsPrompt } from "~features/seated-reservation/helpers/userPrompt";
import { getZoneKeys } from "~features/seated-reservation/helpers/zoneFilters";
import { getState, setState, StoreState } from "../index";
import { selectBestSeats } from "./selectBestSeats";

interface ActionProps {
  section: StoreState["currentSection"];
}

export const setCurrentSection = async (payload: ActionProps) => {
  log("setCurrentSection", payload);

  const state = getState();

  if (dontUnselectSeatsPrompt(state.seats)) {
    return;
  }

  const categoriesKeys = getZoneKeys(payload.section);

  setState({
    currentSection: payload.section,
    availableTicketTypes:
      payload.section.sectionTicketTypes || payload.section.ticketTypes,
    sidebarIndex: 3,
  });

  await selectBestSeats({
    categoryKey: categoriesKeys,
  });
};
